<template>
  <div class="home-content">
    <div class="box">
      <div class="main"></div>
    </div>
    <!-- <vheader></vheader> -->
    <div class="banner">
        <div class="container_data">
        <div class="banner-box">
          <div
            class="left wow slideInLeft"
            data-wow-delay="0.40s"
            data-wow-offset="20"
          >
            <h2>
              <span style="font-size: 28px;">域贝可视化平台（一云看板）</span>
              <div style="font-size: 24px; margin-top: 10px;"></div>
            </h2>
            <p>
              零代码数据可视化看板制作平台 <br />
            </p>
            <div class="btn">
              <el-button type="primary" @click="goLogin">
                立即体验
              </el-button>
              <el-button plain @click="dialogHelpVisible = true" >立即咨询</el-button>
            </div>
            <!-- <div class="banner-icon">
              <img src="../../assets/images/banner-icon.png" alt="" srcset="" />
            </div> -->
          </div>
          <div class="right">
            <div class="xiaokanban">
                <img
                src="../../assets/images/动态模版1.png"
                :class="{ active: active3 == 0 }"
                  style="opacity: 0;"
                alt=""                
              />
                <img
                src="../../assets/images/动态模版2.png"
                  :class="{ active: active3 == 1 }"
                  style="opacity: 0;"
                alt=""                
              />
                <img
                src="../../assets/images/动态模版3.png"
                :class="{ active: active3 == 2 }"
                  style="opacity: 0;"
                alt=""                
              />
            </div>
            <div class="mobilekanban">
              <img
                src="../../assets/images/手机长图1.png"
                :class="{ active: active3 == 0 }"
                  style="opacity: 0;"
                alt=""                
              />
                <img
                src="../../assets/images/手机长图2.png"
                  :class="{ active: active3 == 1 }"
                  style="opacity: 0;"
                alt=""                
              />
                <img
                src="../../assets/images/手机长图3.png"
                :class="{ active: active3 == 2 }"
                  style="opacity: 0;"
                alt=""                
              />
            </div>
            <div class="bigkanban">
              <img
                src="../../assets/images/数据大屏1.png"
                :class="{ active: active3 == 0 }"
                  style="opacity: 0;"
                alt=""                
              />
                <img
                src="../../assets/images/数据大屏2.png"
                  :class="{ active: active3 == 1 }"
                  style="opacity: 0;"
                alt=""                
              />
                <img
                src="../../assets/images/数据大屏3.png"
                :class="{ active: active3 == 2 }"
                  style="opacity: 0;"
                alt=""                
              />
            </div> 
          </div>
          <!-- <div
            class="right wow slideInRight"
            data-wow-delay="0.20s"
            data-wow-offset="20"
          > -->
          <!-- <div
            class="right"
          >
            <img src="../../assets/images/背景.png" alt="" srcset="" />
            <div
            class="btn"
            :class="{ active: active3 === '园区' }"
            @mouseenter="onMouseEnter('园区')"
            @mouseleave="onMouseleave(0)"
            >
            </div>
            <div
            class="btn"
            :class="{ active: active3 === '学校' }"
            @mouseenter="onMouseEnter('学校')"
            @mouseleave="onMouseleave(1)"
            >
            </div>
            <div
            class="btn"
            :class="{ active: active3 === '工厂' }"
            @mouseenter="onMouseEnter('工厂')"
            @mouseleave="onMouseleave(2)"

            >
            </div>
            <div
            class="btn"
            :class="{ active: active3 === '交通' }"
            @mouseenter="onMouseEnter('交通')"
            @mouseleave="onMouseleave(3)"

            >
            </div>
            <div class="single-func"
            :class="{ active: active3 === '园区' }"
             style="opacity: 0;" >
            
              <img
                src="../../assets/images/园区@0.5x.png"
                alt=""
              />
          </div>
          <div 
            :class="{ active: active3 === '学校' }"
          
           class="single-func" style="opacity: 0;" >
            
              <img
                src="../../assets/images/学校@0.5x.png"
                alt=""
                class=" gif"
                
              />
          </div>
          <div class="single-func" 
            :class="{ active: active3 === '工厂' }"
          
           style="opacity: 0;" >
            <img
                src="../../assets/images/工厂@0.5x.png"
                alt=""
                class=" gif"
                
              />
          </div>
          <div
            :class="{ active: active3 === '交通' }"
          
           class="single-func" style="opacity: 0;">
            <img
                src="../../assets/images/交通@0.5x.png"
                alt=""
                class=" gif"
                
              />
          </div> -->
            <!-- <div class="flow">
              <img src="../../assets/images/flow.png" alt="" srcset="" />
              <div class="one"></div>
              <div class="two"></div>
              <div class="three"></div>
              <div class="four"></div>
              <div class="five"></div>
            </div> -->
            <!-- <div class="circle-one">
              <img src="../../assets/images/man-down.png" alt="" srcset="" />
            </div>
            <div class="circle-two">
              <img src="../../assets/images/man-down.png" alt="" srcset="" />
            </div> -->
            <!-- <div class="ce">
              <img
                src="../../assets/images/certificate1.png"
                alt=""
                class="ce-one"
              />
              <img
                src="../../assets/images/certificate2.png"
                alt=""
                class="ce-two"
              />
              <img
                src="../../assets/images/certificate3.png"
                alt=""
                class="ce-three"
              />
              <img
                src="../../assets/images/certificate4.png"
                alt=""
                class="ce-four"
              />
              <img
                src="../../assets/images/certificate-box1.png"
                alt=""
                class="ce-box"
              />
            </div> -->
          <!-- </div> -->
        </div>
      </div>
        <div class="container_data product-advantages">
        <div
          class="title wow fadeInUp"
          data-wow-delay="0.05s"
          data-wow-offset="20"
        >
          产品优势
        </div>
        <div class="icon-box">
          <div
            class="single-icon wow fadeInUp"
            data-wow-delay="0.05s"
            data-wow-offset="20"
          >
            <div class="img boxshow-one">
              <img src="../../assets/images/andvantage-one.png" alt="" srcset="" />
            </div>
            <div class="text">精美模版，适用多行业</div>
          </div>
          <div
            class="single-icon wow fadeInUp"
            data-wow-delay="0.10s"
            data-wow-offset="20"
          >
            <div class="img boxshow-two">
              <img src="../../assets/images/andvantage-two.png" alt="" srcset="" />
            </div>
            <div class="text">简单易学，可轻松上手</div>
          </div>
          <div
            class="single-icon wow fadeInUp"
            data-wow-delay="0.15s"
            data-wow-offset="20"
          >
            <div class="img boxshow-three">
              <img
                src="../../assets/images/andvantage-three.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="text">实时接入，主流数据库</div>
          </div>
          <div
            class="single-icon wow fadeInUp"
            data-wow-delay="0.20s"
            data-wow-offset="20"
          >
            <div class="img boxshow-four">
              <img
                src="../../assets/images/andvantage-four.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="text">兼容并包，开放第三方</div>
          </div>
        </div>
      </div>

    </div>
    <div class="product-advantages">
      <div
      class="text wow fadeInUp"
          data-wow-delay="0.05s"
          data-wow-offset="20"
          >
              <h2>为什么选择域贝可视化</h2>
              <p>零代码数据可视化平台</p>
            </div>
      <div class="content">
        <div class="container_data">
          <div
      class="wow fadeInUp"
          data-wow-delay="0.05s"
          data-wow-offset="20"
          >
          <div 
          class="tab-text"
          v-if="active2 === '精美模版'"
          >
          <div class="num">01</div>
          <h2>精美模版 超多素材</h2>
          <p>数十款精美模板任你选择，图表、地图、等零代码调整，实现专属于你的个性看板，超多场景适用，同一模版可适配不同场景</p>
          </div>
          <div 
          class="tab-text"
          v-if="active2 === '简易编辑'"
          >
          <div class="num">02</div>
          <h2>简易编辑 一步到位</h2>
          <p>后台填充数据，无更多繁琐操作，数据看板自动变化</p>
          </div>
          <div 
          class="tab-text"
          v-if="active2 === '看板互联'"
          >
          <div class="num">03</div>
          <h2>看板互联 快速切换</h2>
          <p>实时动态更新，数据汇总，一键切换看板，多屏分享同时展示，无需等待</p>
          </div>
          <div 
          class="tab-text"
          v-if="active2 === '自定义分享'"
          >
          <div class="num">04</div>
          <h2>自定义 多功能分享</h2>
          <p>“傻瓜式”快速生成一键分享，将精心制作的看板与同事、领导共享，简单又快捷！</p>
          </div>
          </div>
          <div class="content-tab">
            <div
            class="left wow slideInLeft"
            data-wow-delay="1s"
            data-wow-offset="20"
          >
              <div
              class="tab-item"
              :class="{ active: active2 === '精美模版' }"
              @click="active2 = '精美模版'"
              >
              <span>01</span>
                &nbsp;&nbsp;精美模版
              </div>
              <div
              class="tab-item"
              :class="{ active: active2 === '简易编辑' }"
              @click="active2 = '简易编辑'"
              >
              <span>02</span>
                &nbsp;&nbsp;简易编辑
              </div>
              <div
              class="tab-item"
              :class="{ active: active2 === '看板互联' }"
              @click="active2 = '看板互联'"
              >
              <span>03</span>
                &nbsp;&nbsp;看板互联
              </div>
              <div
              class="tab-item"
              :class="{ active: active2 === '自定义分享' }"
              @click="active2 = '自定义分享'"
              >
              <span>04</span>
                &nbsp;&nbsp;自定义分享
              </div>
            </div>
            <div
              class="wow slideInRight right"
              data-wow-delay="1s"
              data-wow-offset="20"
              >
              <img
                src="../../assets/images/海量模版.gif"
                alt=""
                class=" gif"
                v-if="active2 === '海量模版'"
              />
              <img
                src="../../assets/images/简易编辑.gif"
                alt=""
                class=" gif"
                v-if="active2 === '简易编辑'"

              />
              <img
                src="../../assets/images/看板互联.gif"
                alt=""
                class=" gif"
                v-if="active2 === '看板互联'"

              />
              <img
                src="../../assets/images/自定义分享.gif"
                alt=""
                class=" gif"
                v-if="active2 === '自定义分享'"
                
              />
        </div>
          </div>
        <!-- <div class="process-container">
      <div class="container_data">
        <div class="process">
          <div
            class="left wow slideInLeft"
            data-wow-delay="1s"
            data-wow-offset="20"
          >
            <div
            class="process_item-circle"
            :class="{ active: active2 === '个性化' }"
            @click="active2 = '个性化'"
            style="top: 64px; left: 170px;"
            >
            海量模版<br />超多素材
            </div>
            <div
            class="process_item-circle"
            :class="{ active: active2 === '后台修改' }"
            @click="active2 = '后台修改'"
            style="top: 216px; left: 242px;">
            简易编辑<br />一步到位
            </div>
            <div
            class="process_item-circle"
            :class="{ active: active2 === '看板互联' }"
            @click="active2 = '看板互联'"
            style="top: 368px; left: 242px;">
            看板互联<br />快速切换
            </div>
            <div
            class="process_item-circle"
            :class="{ active: active2 === '自定义' }"
            @click="active2 = '自定义'"
            style="top: 520px; left: 170px;">
            自定义<br />多功能分享
            </div>
            
          </div>
          <div class="right">
            <div class="single-func" v-if="active2 === '个性化'">
            <div
              class="wow slideInRight right"
              data-wow-delay="1s"
              data-wow-offset="20">
              <img
                src="../../assets/images/海量模版.gif"
                alt=""
                class=" gif"
                
              />
              <p>数十款精美模板任你选择，图表、地图、等零代码调整，实现专属于你的个性看板，超多场景适用，同一模版
可适配不同场景</p>
            </div>
          </div>
          <div class="single-func" v-if="active2 === '后台修改'">
            <div
              class=" right">
              <img
                src="../../assets/images/简易编辑.gif"
                alt=""
                class=" gif"
                
              />
              <p>后台填充数据，无更多繁琐操作，数据看板自动变化</p>
            </div>
          </div>
          <div class="single-func" v-if="active2 === '看板互联'">
            <div
              class="right">
              <img
                src="../../assets/images/看板互联.gif"
                alt=""
                class=" gif"
                
              />
              <p>实时动态更新，海量数据汇总，一键切换看板，多屏分享同时展示，无需等待</p>
            </div>
          </div>
          <div class="single-func" v-if="active2 === '自定义'">
            <div
              class="right">
              <img
                src="../../assets/images/自定义分享.gif"
                alt=""
                class=" gif"
                
              />
              <p>“傻瓜式”快速生成一键分享，将精心制作的看板与同事、领导共享，简单又快捷！ </p>
            </div>
          </div>
          </div>
        </div>
        </div>
      </div> -->
    </div>
    </div>
    </div>

    <div class="special-function">
      <div class="container_data">
        <div
          class="title wow fadeInUp"
          data-wow-delay="0.05s"
          data-wow-offset="20"
        >
        域贝可视化可应用于众多场景
          <p>一起探索更多应用场景，无限延伸可视化未来</p>
        </div>
        <div
          class="btn-group wow fadeInUp"
          data-wow-delay="0.05s"
          data-wow-offset="20"
        >
          <div
            class="btn"
            :class="{ active: active === '数字工厂' }"
            @mouseenter="active = '数字工厂'"
          >
            <img src="../../assets/images/工厂_factory-building.svg" alt="" style="display: none;">
            <img src="../../assets/images/工厂_factory-building-2.svg" alt="" style="display: inline;">
              数字工厂
          </div>
          <div
            class="btn"
            :class="{ active: active === '智慧城市' }"
            @mouseenter="active = '智慧城市'"
          >
          <img src="../../assets/images/建筑_building-two.svg" alt="" style="display: none;">
            <img src="../../assets/images/建筑_building-two-2.svg" alt="" style="display: inlinenone;">
            智慧城市
          </div>
          <div
            class="btn"
            :class="{ active: active === '智慧园区' }"
            @mouseenter="active = '智慧园区'"
          >
          <img src="../../assets/images/山_mountain.svg" alt="" style="display: none;">
            <img src="../../assets/images/山_mountain-2.svg" alt="" style="display: inlinenone;">
            智慧园区
          </div>
          <div
            class="btn"
            :class="{ active: active === '智慧校园' }"
            @mouseenter="active = '智慧校园'"
          >
          <img src="../../assets/images/已定位_local.svg" alt="" style="display: none;">
            <img src="../../assets/images/已定位_local-2.svg" alt="" style="display: inlinenone;">
            智慧校园
          </div>
          <div
            class="btn"
            :class="{ active: active === '设备管理' }"
            @mouseenter="active = '设备管理'"
          >
          <img src="../../assets/images/控制器_control.svg" alt="" style="display: none;">
            <img src="../../assets/images/控制器_control-2.svg" alt="" style="display: inlinenone;">
            设备管理
          </div>
          <div
            class="btn"
            :class="{ active: active === '智慧医疗' }"
            @mouseenter="active = '智慧医疗'"
          >
          <img src="../../assets/images/健康_health.svg" alt="" style="display: none;">
            <img src="../../assets/images/健康_health-2.svg" alt="" style="display: inlinenone;">
            智慧医疗
          </div>
          <div
            class="btn"
            :class="{ active: active === '物流管理' }"
            @mouseenter="active = '物流管理'"
          >
          <img src="../../assets/images/送货车_transporter.svg" alt="" style="display: none;">
            <img src="../../assets/images/送货车_transporter-2.svg" alt="" style="display: inlinenone;">
            物流管理
          </div>
          <div
            class="btn"
            :class="{ active: active === '智慧交通' }"
            @mouseenter="active = '智慧交通'"
          >
          <img src="../../assets/images/地图_map-road-two.svg" alt="" style="display: none;">
            <img src="../../assets/images/地图_map-road-two-2.svg" alt="" style="display: inlinenone;">
            智慧交通
          </div>
        </div>
        <div class="special-group">
          <div class="single-func" v-if="active === '数字工厂'">
            <!-- <div
              class="left wow slideInLeft"
              data-wow-delay="0.20s"
              data-wow-offset="20"
            >
              <h2 class="green">个性化</h2>
              <h2>看板定制</h2>
              <p>
                数十款精美模板任你选择，图表、地图、零代码调<br />
                整，实现专属于你的个性看板 <br />
              </p>
            </div> -->
            <div class="right">
              <img
                src="../../assets/MP4/工程.gif"
                alt=""
                class="wow fadeInUp gif"
                data-wow-delay="0.40s"
                data-wow-offset="20"
              />
              <!-- <div
                class="design wow slideInRight"
                data-wow-delay="0.20s"
                data-wow-offset="20"
              >
                <img src="../assets/images/design1.png" alt="" />
              </div> -->
              <!-- <div
                class="bg wow slideInRight"
                data-wow-delay="0.20s"
                data-wow-offset="20"
              >
                <img src="../../assets/images/bg-green.png" alt="" />
              </div> -->
            </div>
          </div>
          <div class="single-func" v-if="active === '智慧城市'">
            <!-- <div class="left">
              <h2 class="red">动态</h2>
              <h2>数据接入</h2>
              <p>
                支持多款主流数据库接入，搭配专业脚本语言分析<br />
                接口,完美满足企业专业化动态数据接入
              </p>
            </div> -->
            <div class="right">
              <img
                src="../../assets/MP4/城市.gif"
                alt=""
                class="gif"
              />
              <!-- <div class="daoru">
                <img src="../assets/images/daoru.png" alt="" />
              </div> -->
              <!-- <div class="fabu">
                <img src="../assets/images/fabu1.png" alt="" />
              </div> -->
              <!-- <div class="bg">
                <img src="../../assets/images/bg-red.png" alt="" />
              </div> -->
            </div>
          </div>
          <div class="single-func" v-if="active === '智慧园区'">
            <!-- <div class="left">
              <h2 class="blue">自定义</h2>
              <h2>多功能分享</h2>
              <p>
                自定义密码保护数据隐私，导入看板实现数据分享 <br />
                一键复制链接轻松访问
              </p>
            </div> -->
            <div class="right">
              <img
                src="../../assets/MP4/园区.gif"
                alt=""
                class="gif"
              />
              <!-- <div class="quality">
                <img src="../assets/images/quality.png" alt="" />
              </div> -->
              <!-- <div class="bg">
                <img src="../../assets/images/bg-blue.png" alt="" />
              </div> -->
            </div>
          </div>
          <div class="single-func" v-if="active === '智慧校园'">
            <div class="right">
              <img
                src="../../assets/MP4/校园.gif"
                alt=""
                class="gif"
              />
            </div>
          </div>
          <div class="single-func" v-if="active === '设备管理'">
            <div class="right">
              <img
                src="../../assets/MP4/设备.gif"
                alt=""
                class="gif"
              />
            </div>
          </div>
          <div class="single-func" v-if="active === '智慧医疗'">
            <div class="right">
              <img
                src="../../assets/MP4/医疗.gif"
                alt=""
                class="gif"
              />
            </div>
          </div>
          <div class="single-func" v-if="active === '物流管理'">
            <div class="right">
              <img
                src="../../assets/MP4/物流.gif"
                alt=""
                class="gif"
              />
            </div>
          </div>
          <div class="single-func" v-if="active === '智慧交通'">
            <div class="right">
              <img
                src="../../assets/MP4/交通.gif"
                alt=""
                class="gif"
              />
            </div>
          </div>
        </div>
        <!-- <div class="green-plan">
          <div
            class="left wow slideInLeft"
            data-wow-delay="0.20s"
            data-wow-offset="20"
          >
            <img src="../assets/images/green-plan.png" alt="" />
            <div class="cloud-one">
              <img src="../assets/images/cloud-one.png" alt="" />
            </div>
            <div class="cloud-two">
              <img src="../assets/images/cloud.png" alt="" />
            </div>
            <div class="light">
              <img src="../assets/images/light-w.png" alt="" />
              <img src="../assets/images/light-y.png" alt="" class="light-y" />
            </div>
            <div class="light-two">
              <img src="../assets/images/light-top.png" alt="" />
            </div>
            <div class="text-one">
              <img src="../assets/images/text-one.png" alt="" />
            </div>
            <div class="text-two">
              <img src="../assets/images/text-two.png" alt="" />
            </div>
            <div class="water">
              <div class="water-one">
                <img src="../assets/images/watering1.png" alt="" />
              </div>
              <div class="water-two">
                <img src="../assets/images/watering2.png" alt="" />
              </div>
              <div class="water-three">
                <img src="../assets/images/watering3.png" alt="" />
              </div>
            </div>
            <div class="yezi-one">
              <img src="../assets/images/yezi1.png" alt="" />
            </div>
            <div class="yezi-two">
              <img src="../assets/images/yezi2.png" alt="" />
            </div>
          </div>
          <div
            class="right wow slideInRight"
            data-wow-delay="0.20s"
            data-wow-offset="20"
          >
            <div class="min-title">
              绿“智造”创未来——<span>零碳未来计划</span>
            </div>
            <p>
              每一张数字化颁发可以直接<span>减少碳排放2.6克，</span>我们的目标希望<span
                >能用数字化来智造一个低碳零碳的未来世界。</span
              >
            </p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="Personal-customization">
      <div class="container_data">
        <div class="left-box">
        <div
            class="left wow slideInLeft"
            data-wow-delay="0.40s"
            data-wow-offset="20"
          >
            <h2>个性化定制模版</h2>
            <p>量身定制专属模版</p>
            <p>
              数据可视化大屏作为数据价值最直观的体现，广泛应用于<br/>日常办公、应急处理、指挥调度、科学决策等场景。
            </p>
              <el-button class="btn" type="primary" size="medium" @click="dialogHelpVisible = true">
                了解详情
              </el-button>
            <!-- <div class="banner-icon">
              <img src="../../assets/images/banner-icon.png" alt="" srcset="" />
            </div> -->
          </div>
          <div
            class="right wow slideInRight"
            data-wow-delay="0.40s"
            data-wow-offset="20"
          >
          <img src="../../assets/images/中间图形.png" alt="">
          </div>
          </div>
      </div>
      </div>

    
    <div class="application">
      <div class="container_data">
        <!-- <div
          class="title wow fadeInUp"
          data-wow-delay="0.05s"
          data-wow-offset="20"
        >
          域贝数据可视化应用平台可应用于多领域场景
          <p>我们期待你来一起探索更多应用场景，无限延伸我们的未来</p>
        </div> -->
        <div>
          <!-- <swiper></swiper> -->
        </div>
        
      </div>
    </div>
    
    <div class="contact">
      <div class="container_data">
        <div class="contact-box">
          <div
            class="left wow slideInLeft"
            data-wow-delay="0.20s"
            data-wow-offset="20"
          >
            <h3 style="font-size: 24px;">联系我们，免费试用域贝可视化</h3>
            <el-button type="primary" @click="goLogin" style="width: 120px; height: 47px; font-size: 16px;">
                立即体验
              </el-button>
          </div>
          <div
            class="right wow slideInRight"
            data-wow-delay="0.20s"
            data-wow-offset="20"
          >
            <div class="contact-img">
              <img src="../../assets/images/contact1.png" alt="" />
              <img src="../../assets/images/contact-two.png" alt="" class="poab" />
              <img src="../../assets/images/yan.png" alt="" class="yan" />
              <img
                src="../../assets/images/contact-light.png"
                alt=""
                class="contact-light"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogHelpVisible" width="25%">
      <template #title>
        <div style="font-size: 18px; color: #000;">详情咨询微信</div>
      </template>
      <div class="success_dialog" style="text-align: center">
        <!-- <div class="dialog_first">
          <i class="el-icon-circle-check" style="color: #29B000; font-size: 30px; font-weight: 700;"></i>
          <span style="color: #29B000; font-size: 20px; margin-left: 10px; font-weight: 700;">购买成功</span>
        </div> -->
        <div style="color: #999; font-size: 16px; margin-top: 30px;">
          扫描下方二维码，获取详细资料
        </div>
        <div>
          <img style="width: 226px; height: 226px" src="../../assets/images/qr-code_qywx.png" alt="" />
        </div>
        <!-- <el-button type="primary" style="margin-top: 15px; margin-bottom: 20px;" @click="onClickGo">立即体验</el-button> -->
      </div>
    </el-dialog>
    <!-- <vfooter></vfooter> -->
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { popularizeLog } from "@/api/logs"
// import vheader from "../components/header.vue";
// import vfooter from "../components/footer.vue";
// import swiper from "../../components/swiper.vue";
export default {
  components: {
    // vheader,
    // vfooter,
    // swiper,
  },
  data() {
    return {
      active: "数字工厂",
      active2: "海量模版",
      active3:"0",
      dialogHelpVisible: false,
      time1:null,
      valueList:[0,1,2,3],
    };
  },

  created() {},

  mounted() {
    let i =0;
    new WOW().init();
        this.time1 = setInterval(() => {
          i=i+1
          this.active3=this.valueList[i%3]
        }, 3000);
    
    popularizeLog({ url: window.location.href })
    if (Object.keys(this.$route.query).length > 0) {
      sessionStorage.setItem("query", JSON.stringify(this.$route.query))
    }
  },
  destroyed() {
    clearInterval(this.time1);
  },

  methods: {
    goLogin() {
      console.log(sessionStorage.getItem("query"))
      const query = JSON.parse(sessionStorage.getItem("query")) || {}
      console.log(query)
      if (Object.keys(this.$route.query).length > 0) {
        // 获取?后面的参数
        const params = window.location.href.split("?")[1]
        window.open("http://yb.yuzanyun.com/#/login?" + params) 
      } else if (Object.keys(query).length > 0) {
        // 拼接query, 去掉最后的&
        let params = ""
        for (let i = 0; i < Object.keys(query).length; i++) {
          if (i === Object.keys(query).length - 1) {
            params += Object.keys(query)[i] + "=" + Object.values(query)[i]
            break
          }
          params += Object.keys(query)[i] + "=" + Object.values(query)[i] + "&"
        }
        window.open("http://yb.yuzanyun.com/#/login?" + params)
      }
       else {
        window.open("http://yb.yuzanyun.com/#/") 
      }
    },
    onMouseEnter(str){
      this.active3 = str;
      clearInterval(this.time1);
    },
    onMouseleave(val){
      let i = val;
      this.time1 = setInterval(() => {
          i=i+1
          console.log(this.active3=this.valueList[i%4],i%4)
        }, 2000);
    }
  },
};
</script>
<style lang="scss" scoped>
*, ::after, ::before {
  box-sizing: border-box;
}
body{
  display: block;
  margin: 0;
  font-family: "PingFangSC-Regular", sans-serif;
/*font-family: "PingFangSC-Ultralight", sans-serif;*/
/*font-family: "PingFangSC-Light", sans-serif;*/
/* font-family: "PingFangSC-Thin", sans-serif; */
  /* font-family: "PingFangSC-Medium", sans-serif; */
  /* font-family: "PingFangSC-Semibold", sans-serif; */
}
.container_data{
  max-width: 1200px;
  margin: 0 auto;
}
@media screen and (max-width:1300px) {
  .container_data{
      overflow: hidden;
  }
}
img{
  max-width: 100%;
}
/* @font-face {
  font-family: 'PingFangSC-Regular';
  src: url('./PingFangSC-Regular.ttf');
  font-weight: normal;
  font-style: normal;
} */

h1,h2,h3,h4,h5,h6,p{margin: 0;line-height: 1.4;font-weight: normal;color: #444;}
a{
  text-decoration: none;
  display: inline-block;
}
ul{
  padding: 0;
  margin: 0;
  list-style: none;
}
.case-group .ivu-modal-footer{
  display: none;
}
.case-group .dl{
  margin-top: 25px;
}
.case-group .dl a{
  width: 140px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #1989ff;
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #1989ff;
}


.home-content {
  .success_dialog {
  width: 100%;
  height: 100%;


}
  .banner {
    position: relative;
    z-index: 2;
      // background: url(../../assets/images/bg-banner2.png) center/cover;
      // background: url(../../assets/images/首图背景@0.5x.png) center/cover;
      background: url(../../assets/images/背景43.png) center/cover;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      // background: url(../../assets/images/bg-banner.png) center/cover;
      width: 994px;
      height: 431px;
      z-index: -1;
    }
    .banner-box {
      display: flex;
      align-items: center;
      .left {
        flex: 0 0 50%;
        position: relative;
        .banner-icon {
          position: absolute;
          top: calc(100% + 36px);
          left: -55px;
          width: 206px;
          height: 131px;
        }
        h2 {
          font-size: 32px;
          margin-bottom: 30px;
          font-family: "PingFangSC-Medium", sans-serif;
          font-weight: 500;//Medium=500;
          // color: rgba(255, 255, 255, 1);
          color: #0D1924;
          span {
            font-size: 42px;
          }
        }
        p {
          margin: 0;
          font-size: 20px;
          font-weight: 400;//Regular=400;
          font-family: 'PingFangSC-Regular';
          // color: rgba(255, 255, 255, .6);
          color: #51677E;
        }
        .btn {
          margin-top: 70px;
          margin-bottom: 10px;
          font-size: 16px;
          >:nth-child(1){
            width: 120px;
height: 46px;
              font-size: 16px;
          }
          >:nth-child(2){
            width: 120px;
height: 46px;
              background: transparent !important;
              border: 1px solid rgba(25, 137, 255, 1);
              color:rgba(25, 137, 255, 1);
              margin-left: 24px;
              font-size: 16px;
          }
        }
      }
//       .right {
//         flex: 0 0 50%;
//         // padding-left: 99px;
//         position: relative;
//         z-index: 2;
//         margin: 53px 0;
//         height: 415px;
//         img {
//           position: relative;
//           left: -116px;
//           width:714px;
//           height:415px;
//           max-width:none;
//         }
//         .btn{
//           z-index: 2;
//         }
//         >:nth-child(2).btn {
//           position: absolute;
//           left: 244px;
//           top: 132px;
//           width: 65px;
// height: 29px;
//           cursor: pointer;//悬浮时变手指
//           background-color: transparent;
//       background: url(../../assets/images/园区-未选中.png) center;
//       background-size: 100% 100%;
//         }
//         >:nth-child(2).btn.active {
//       background: url(../../assets/images/园区-选中.png) center;    
//       background-size: 100% 100%;
//           // cursor: default;

//       }
//       >:nth-child(3).btn {
//           position: absolute;
//           left: 264px;
//           top: 177px;
//           width: 65px;
// height: 29px;
//           cursor: pointer;//悬浮时变手指

//           background-color: transparent;
//       background: url(../../assets/images/学校-未选中.png) center;
//       background-size: 100% 100%;
//         }
//         >:nth-child(3).btn.active {
//       background: url(../../assets/images/学校-选中.png) center;    
//       background-size: 100% 100%;
//           // cursor: default;

//       }
//       >:nth-child(4).btn {
//           position: absolute;
//           left: 258px;
//           top: 222px;
//           width: 65px;
// height: 29px;
//           cursor: pointer;//悬浮时变手指

//           background-color: transparent;
//       background: url(../../assets/images/工厂-未选中.png) center;
//       background-size: 100% 100%;
//         }
//         >:nth-child(4).btn.active {
//       background: url(../../assets/images/工厂-选中.png) center;    
//       background-size: 100% 100%;
//           // cursor: default;

//       }
//       >:nth-child(5).btn {
//           position: absolute;
//           left: 231px;
//           top: 267px;
//           width: 65px;
// height: 29px;
//           background-color: transparent;
//           cursor: pointer;//悬浮时变手指

//       background: url(../../assets/images/交通-未选中.png) center;
//       background-size: 100% 100%;
//         }
//         >:nth-child(5).btn.active {
//       background: url(../../assets/images/交通-选中.png) center;    
//       background-size: 100% 100%;
//           // cursor: default;

//       }
//       .single-func{
//         position: absolute;
//         left: 80px!important;
//         top: 31px!important;
// z-index: 1;
//     transition: opacity .4s!important;

// img{
//   width: 390px;
// height: 393px;
// }
//       }
//       .single-func.active{
//         position: absolute;
//         left: 80px!important;
//         top: 31px!important;
// z-index: 1;
// opacity: 1!important;
//     // transition: opacity .4s!important;

// img{
//   width: 390px;
// height: 393px;
// }
//       }
//         // padding-top: 59px;
//         // padding-bottom: 59px;
//         // .flow {
//         //   width: 301px;
//         //   height: 225px;
//         //   position: absolute;
//         //   top: 178px;
//         //   right: 175px;
//         //   z-index: -1;
//         //   overflow: hidden;
//         //   .one {
//         //     position: absolute;
//         //     width: 80px;
//         //     height: 5px;
//         //     background: linear-gradient(
//         //       to left,
//         //       rgb(191 243 250 / 60%),
//         //       rgb(106 210 239 / 60%)
//         //     );
//         //     top: 183px;
//         //     left: 200px;
//         //     transform: rotate(-27deg) scaleX(0);
//         //     transform-origin: right;
//         //     animation: flow-one 3s infinite linear;
//         //     border-radius: 5px;
//         //   }
//         //   .two {
//         //     position: absolute;
//         //     width: 5px;
//         //     height: 225px;
//         //     background: linear-gradient(
//         //       to top,
//         //       rgb(86 184 233 / 60%),
//         //       rgb(105 208 239 / 60%)
//         //     );
//         //     top: -4px;
//         //     left: 188px;
//         //     transform: rotate(-59deg) scaleY(0);
//         //     transform-origin: bottom;
//         //     animation: flow-two 3s infinite linear;
//         //     border-radius: 5px;
//         //   }
//         //   .three {
//         //     position: absolute;
//         //     width: 135px;
//         //     height: 5px;
//         //     background: linear-gradient(
//         //       to left,
//         //       rgb(108 212 239 / 60%),
//         //       rgb(78 174 231 / 60%)
//         //     );
//         //     top: 101px;
//         //     left: 10px;
//         //     transform: rotate(-30deg) scaleX(0);
//         //     transform-origin: left;
//         //     animation: flow-three 3s infinite linear;
//         //     border-radius: 5px;
//         //   }
//         //   .four {
//         //     position: absolute;
//         //     width: 5px;
//         //     height: 55px;
//         //     background: linear-gradient(
//         //       to top,
//         //       rgb(129 233 236 / 60%),
//         //       rgb(167 242 245 / 60%)
//         //     );
//         //     top: -20px;
//         //     left: 124px;
//         //     transform: rotate(-53deg) scaleY(1);
//         //     animation: flow-four 3s infinite linear;
//         //     transform-origin: bottom;
//         //     border-radius: 5px;
//         //   }
//         //   .five {
//         //     position: absolute;
//         //     width: 20px;
//         //     height: 4px;
//         //     background: linear-gradient(
//         //       to left,
//         //       rgb(106 210 239 / 60%),
//         //       rgb(86 184 233 / 60%)
//         //     );
//         //     top: 220px;
//         //     left: 189px;
//         //     transform: rotate(7deg) scaleX(1);
//         //     transform-origin: right;
//         //     animation: flow-five 3s infinite linear;
//         //     border-radius: 5px;
//         //   }
//         // }
//         // .ce {
//         //   position: absolute;
//         //   width: 203px;
//         //   height: 152px;
//         //   top: 110px;
//         //   left: 88px;
//         //   z-index: -1;
//         //   .ce-one {
//         //     position: absolute;
//         //     top: -40px;
//         //     left: -34px;
//         //     z-index: 5;
//         //     animation: certificate-one 3s infinite linear;
//         //   }
//         //   .ce-two {
//         //     position: absolute;
//         //     top: -62px;
//         //     left: -12px;
//         //     z-index: 4;
//         //     animation: certificate-two 3s infinite linear;
//         //   }
//         //   .ce-three {
//         //     position: absolute;
//         //     top: -80px;
//         //     left: 8px;
//         //     z-index: 3;
//         //     animation: certificate-three 3s infinite linear;
//         //   }
//         //   .ce-four {
//         //     position: absolute;
//         //     top: -98px;
//         //     left: 30px;
//         //     z-index: 2;
//         //     animation: certificate-four 3s infinite linear;
//         //   }
//         //   // .ce-five {
//         //   //   position: absolute;
//         //   //   top: -40px;
//         //   //   left: 100px;
//         //   //   z-index: 1;
//         //   //   animation: certificate-five 3s infinite linear;
//         //   // }
//         //   .ce-box {
//         //     position: absolute;
//         //     left: -50px;
//         //     bottom: 36px;
//         //     z-index: 6;
//         //   }
//         // }
//         // .circle-one {
//         //   position: absolute;
//         //   width: 86px;
//         //   height: 58px;
//         //   top: 310px;
//         //   left: 70px;
//         //   z-index: -1;
//         // }
//         // .circle-two {
//         //   position: absolute;
//         //   width: 86px;
//         //   height: 58px;
//         //   top: 383px;
//         //   left: 205px;
//         //   z-index: -1;
//         // }
//       }
          .right {
            flex: 0 0 50%;
            position: relative;
            height: 584px;
            .xiaokanban {
              position: absolute;
              top: 75px;
              right: 560px;
              width: 128px;
height: 232px;
              background: url(../../assets/images/动态模版背景.png) center/cover;
              img {
                position: absolute;
                width: 128px;
height: 232px;
              }
              img.active{
                position: absolute;
                opacity: 1!important;
                transition: opacity .4s!important;
      }
            }
            .mobilekanban {
              position: absolute;
              width: 141px;
height: 415px;
              top: 127px;
              right: 390px;
              z-index: 1;
              background: url(../../assets/images/手机长图背景.png) center/cover;
              img {
                position: absolute;
                width: 141px;
height: 415px;
              }
              img.active{
                position: absolute;
                opacity: 1!important;
                transition: opacity .8s!important;
            }
            }
            .bigkanban {
              position: absolute;
              top: 40px;
              right: 6px;
              width: 544px;
height: 437px;
              background: url(../../assets/images/数据大屏背景.png) center/cover;
              img {
                position: absolute;

                width: 544px;
height: 437px;
              }
              img.active{
                position: absolute;
                opacity: 1!important;
                transition: opacity .4s!important;
            }
            }
          }
    }
    .product-advantages {
    padding: 0px 0 22px;
              // background: url(../../assets/images/背景（选择）.png) center/cover;
    .title {
      color: #191919;
      font-size: 30px;
      text-align: center;
      line-height: 30px;
      margin-bottom: 50px;
    }
    .icon-box {
      display: flex;
      margin-bottom: 50px;
      .single-icon {
        flex: 0 0 25%;
        text-align: center;
        .text {
          color: #444444;
          font-size: 16px;
          transition: all 0.3s;
        }
        .img {
          margin: 0 auto 15px;
          width: 111px;
          height: 111px;
          padding: 10px;
          img {
            transition: all 0.3s;
            border-radius: 50%;
          }
        }
        &:hover {
          .img {
            img {
              transform: scale(1.08);
            }
          }
          .boxshow-one {
            img {
              box-shadow: 0 3px 8px rgb(158 71 30 / 40%);
            }
          }
          .boxshow-two {
            img {
              box-shadow: 0 3px 8px rgb(26 121 74 / 40%);
            }
          }
          .boxshow-three {
            img {
              box-shadow: 0 3px 8px rgb(21 115 169 / 40%);
            }
          }
          .boxshow-four {
            img {
              box-shadow: 0 3px 8px rgb(145 82 6 / 40%);
            }
          }
          .text {
            color: #1989ff;
          }
        }
      }
    }
  }
  }
  .product-advantages {
    .text {
      margin-top: 50px;
      text-align: center;
      h2 {
        font-size: 30px;
font-family: PingFang SC;
font-weight: 400;
color: #191919;
line-height: 30px;
      }
      p {
        margin-top: 28px;
        font-size: 16px;
font-family: PingFang SC;
font-weight: 400;
color: #8A94A9;
line-height: 30px;
      }
    }
    .content {
      .num {
        margin-top: 30px;
        line-height: 0px;
        font-size: 38px;
font-family: PingFang SC;
font-weight: 600;
color: #DDE4EA;
      }
      h2 {
        font-size: 20px;
font-family: PingFang SC;
font-weight: 400;
color: #1989FF;
line-height: 30px;
z-index: 1;
      }
      p {
        font-size: 16px;
font-family: PingFang SC;
font-weight: 400;
color: #333333;
line-height: 29px;
      }
      .content-tab {
        display: flex;
      justify-content: center;
        align-items: center;
        height: 500px;
        .left {
          flex: 0 0 35%;
          margin-left: 50px;
          margin-bottom: 35px;
          .tab-item {
            margin-top: 23px;
            width: 213px;
            height: 79px;
            text-align: center;
            line-height: 79px;
            background: #E9F3F8;
            cursor: pointer;
            transition: .3s;
    border-radius: 4px;
    font-size: 18px;
font-family: PingFang SC;
font-weight: 400;
color: #333333;
span {
    vertical-align: bottom;
  font-size: 24px;
font-family: PingFang SC;
font-weight: 600;
color: #1989FF;
}
        }
        .tab-item.active {
          width: 213px;
          height: 79px;
          background: #1989FF;
          box-shadow: 0px 3px 23px 1px rgba(117,182,255,0.53);
          border-radius: 4px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #fff;
          span {
            color: #fff;
          }
          }
        }
        .right {
          flex: 0 0 65%;
          .gif {
            width: 719px;
            height: 404px;
          }
        }
      }
    }
    // padding: 70px 0 60px;
//     .process-container{
//       background: url(../../assets/images/bg-banner4.png) center/cover;
//     .process {
//       display: flex;
//       align-items: center;
//       .left {
//         flex: 0 0 33%;
//         position: relative;
//         // .img-one {
//         //   position: absolute;
//         //   left: -120px;
//         //   top: -120px;
//         //   width: 220px;
//         //   height: 89px;
//         // }
//         // .img-two {
//         //   position: absolute;
//         //   width: 213px;
//         //   height: 116px;
//         //   top: 100%;
//         //   left: -120px;
//         // }
//         height: 690px;
//         .process_item-circle {
//           position: absolute;
//           width: 104px;
//           height: 104px;
//           padding-top: 24px;
//           // color: #8c96a5;
//           // font-size: 16px;
//           // line-height: 28px;
//           text-align: center;
//           // background: rgba(25, 137, 255, 1);
//           // opacity: 0.6;
//           //
//           font-size: 16px;
//           font-family: PingFang SC;
//           font-weight: 400;
//           color: rgba(194, 211, 247, 1);
//           line-height: 30px;
//           // opacity: 0.4;
//           //

// background: rgba(65,81,114,0.09);
//           border-radius: 50%;
//           // box-shadow: inset 0 0 24px rgb(54 54 65 / 56%);
//           cursor: pointer;
//           transition: .3s;
// }
// .process_item-circle.active {
// background: #1989FF;
// color: #FFFFFF;
//         &::after {
//           position: absolute;
//     top: -20px;
//     left: -20px;
//     width: 144px;
//     height: 144px;
//     background: radial-gradient(50% 50% at 50% 50%,hsla(0,0%,9%,0) 53.5%,rgba(58,137,254,.16) 100%);
//     border-radius: 50%;
//     content: "";
//         }
// }
//         .text {
//           width: 310px;
//           // margin-left: 5px;
//           position: absolute;
// 	        top: 50%;
// 	        transform: translateY(-50%);
//         }
//         h2 {
//           // font-size: 30px;
//           // margin-bottom: 20px;
//           // color: #444;
//           // font-family: "PingFangSC-Medium", sans-serif;
//           font-size: 26px;
//           font-family: "PingFang SC";
//           font-weight: 400;
//           color: #FFFFFF;
//         }
//         p {
//           // margin: 0;
//           // color: #444444;
//           // font-size: 16px;
//           margin-top: 27px;
//           font-size: 16px;
//           font-family: PingFang SC;
//           font-weight: 400;
//           color: #C2D3F8;
//           opacity: 0.4;
//         }
//       }
//       .right {
//         flex: 0 0 67%;
//         padding: 29px 0 38px;
//         position: relative;
//         .right{
//           p {
//             margin-top: 30px;
//             // width: 560px;
//             width: 800px;
            
//             height: 17px;
//             font-size: 16px;
//             font-family: PingFang SC;
//             font-weight: 400;
//             color: #FEFEFE;            
//           }
//         }
//         // .mid-img {
//         //   width: 505px;
//         //   height: 505px;
//         //   position: relative;
//         //   z-index: 2;
//         //   .choose {
//         //     position: absolute;
//         //     width: 60px;
//         //     height: 60px;
//         //     background: #009cf9;
//         //     border-radius: 4px;
//         //     top: 0;
//         //     left: 85px;
//         //     img {
//         //       position: absolute;
//         //       width: 32px;
//         //       height: 32px;
//         //       top: 50%;
//         //       left: 50%;
//         //       transform: translate(-50%, -50%);
//         //     }
//         //     .position {
//         //       position: absolute;
//         //       transition: all 0.3s;
//         //       width: 25px;
//         //       height: 25px;
//         //       top: 65%;
//         //       left: 65%;
//         //     }
//         //     &:hover {
//         //       .position {
//         //         top: 80%;
//         //         left: 80%;
//         //       }
//         //     }
//         //   }
//         //   .edit {
//         //     position: absolute;
//         //     width: 60px;
//         //     height: 60px;
//         //     background: #4fd036;
//         //     border-radius: 4px;
//         //     top: 50%;
//         //     right: -20px;
//         //     transform: translateY(-50%);
//         //     img {
//         //       position: absolute;
//         //       width: 40px;
//         //       height: 40px;
//         //       top: 50%;
//         //       left: 50%;
//         //       transform: translate(-50%, -50%);
//         //     }
//         //     .position {
//         //       position: absolute;
//         //       transition: all 0.3s;
//         //       width: 34px;
//         //       height: 34px;
//         //       top: 45%;
//         //       left: 55%;
//         //     }
//         //     &:hover {
//         //       .position {
//         //         top: 30%;
//         //         left: 70%;
//         //       }
//         //     }
//         //   }
//         //   .down {
//         //     position: absolute;
//         //     width: 60px;
//         //     height: 60px;
//         //     background: #ff6656;
//         //     border-radius: 4px;
//         //     bottom: -5px;
//         //     left: 90px;
//         //     img {
//         //       position: absolute;
//         //       width: 40px;
//         //       height: 28px;
//         //       top: 35%;
//         //       left: 50%;
//         //       transform: translateX(-50%);
//         //     }
//         //     .position {
//         //       position: absolute;
//         //       transition: all 0.3s;
//         //       width: 15px;
//         //       height: 29px;
//         //       top: 15%;
//         //     }
//         //     &:hover {
//         //       .position {
//         //         top: 10%;
//         //       }
//         //     }
//         //   }
//         //   .logo {
//         //     position: absolute;
//         //     top: 50%;
//         //     left: 50%;
//         //     transform: translate(-50%, -50%);
//         //     // display: flex;
//         //     // z-index: 2;
//         //     .logo-img {
//         //       // flex: 0 0 29px;
//         //       // height: 29px;
//         //       margin-left: 5px;
//         //       width: 136px;
//         //     }
//         //     .logo-dec {
//         //       color: #1989ff;
//         //       font-size: 24px;
//         //       font-weight: 500;
//         //     }
//         //   }
//         //   .min-img {
//         //     position: absolute;
//         //     width: 412px;
//         //     height: 397px;
//         //     top: 50%;
//         //     left: 50%;
//         //     transform: translate(-50%, -50%);
//         //     .rotate {
//         //       animation: rotate 15s infinite linear;
//         //     }
//         //   }
//         // }
//         // .bg-circle {
//         //   position: absolute;
//         //   width: 572px;
//         //   height: 572px;
//         //   top: 0;
//         //   left: 210px;
//         //   background: url("../../assets/images/large-circle.png") center/cover;
//         //   z-index: -1;
//         // }
//         // .text {
//         //   position: absolute;
//         //   display: flex;
//         //   flex-direction: column;
//         //   top: 0;
//         //   height: 100%;
//         //   right: 15px;
//         //   justify-content: space-between;
//         //   padding: 85px 0;
//         //   z-index: 2;
//         //   .single-text {
//         //     display: flex;
//         //     flex-direction: column;
//         //     width: 299px;
//         //     padding: 0px 15px;
//         //     height: 100px;
//         //     justify-content: space-evenly;
//         //     background: url(../../assets/images/choose-border.png) center/cover;
//         //     transition: all 0.3s;
//         //     border-radius: 7px;
//         //     background-color: #fff;
//         //     h4 {
//         //       color: #444444;
//         //       font-size: 18px;
//         //     }
//         //     p {
//         //       margin: 0;
//         //       font-size: 14px;
//         //       color: #8a94a9;
//         //     }
//         //     &:nth-of-type(odd) {
//         //       margin-left: -45px;
//         //     }
//         //     &:hover {
//         //       box-shadow: 0 5px 5px rgb(6 35 57 / 7%);
//         //       transform: translateY(-5px);
//         //     }
//         //   }
//         //   .edit {
//         //     background: url(../../assets/images/edit-border.png) center/cover;
//         //   }
//         //   .down {
//         //     background: url(../../assets/images/down-border.png) center/cover;
//         //   }
//         // }
//       }
//     }
//     }
  }
  .special-function {
    // .title {
    //   color: #191919;
    //   font-size: 30px;
    //   text-align: center;
    //   line-height: 30px;
    //   margin-bottom: 60px;
    // }
    margin-top: 60px;
    .title {
      color: #191919;
      text-align: center;
      line-height: 30px;
      margin-bottom: 35px;
font-size: 26px;
font-family: 'PingFang SC';
font-weight: 400;
      p {
        font-size: 16px;
        margin-top: 20px;
font-family: "PingFang SC";
font-weight: 400;
color: #8A94A9;
line-height: 30px;
      }
    }
    .btn-group {
      border-bottom: 2px solid #e8e8e8;
      display: flex;
      justify-content: center;
      margin-bottom: 24px;
      position: relative;
      // &::after {
      //   content: "";
      //   position: absolute;
      //   width: 189.3px;
      //   height: 128.2px;
      //   left: 98%;
      //   top: -15px;
      //   background: url(../../assets/images/func-top.png) center/cover;
      // }
      .btn {
        padding-bottom: 20px;
        position: relative;
        margin: 0 30px;
        // color: #8a94a9;
        font-size: 16px;
        cursor: pointer;
//         width: 63px;
// height: 16px;

font-family: 'PingFang SC';
font-weight: 400;
color: #191919!important;
// line-height: 30px;
          // transition: all 0.3s;
        //   >:nth-child(1) {
        //   display: none;
        // }
        img {
vertical-align: bottom;
transition: all 0.3s;

        }
&::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 2px;
          background: #1989ff;
          left: 0;
          bottom: -2px;
          color: #444444;
          opacity: 0;
          transition: all 0.3s;

        }
      }
      .btn.active {
        // color: #444;
color: #1989FF!important;
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 2px;
          background: #1989ff;
          left: 0;
          bottom: -2px;
          color: #444444;
          opacity: 1;
        }
        >:nth-child(1) {
          // opacity: 1!important;
          display: inline !important;
        }
        >:nth-child(2) {
          display: none !important;

        }
      }
    }
    .special-group {
      // padding: 0 45px;
      // position: relative;
      display: flex;
      justify-content: center;
        align-items: center;
      .single-func {
        // .left {
        //   flex: 0 0 32%;
        //   // padding-left: 66px;
        //   h2 {
        //     color: #444;
        //     font-size: 30px;
        //     margin-bottom: 20px;
        //     line-height: 1;
        //     font-family: "PingFangSC-Medium", sans-serif;
        //   }
        //   .green {
        //     color: #30b07c;
        //   }
        //   .blue {
        //     color: #8acef0;
        //   }
        //   .red {
        //     color: #ff6656;
        //   }
        //   p {
        //     color: #444444;
        //     font-size: 16px;
        //     margin-top: 10px;
        //   }
        // }
        .right {
          // flex: 0 0 73%;
          position: relative;
          padding-bottom: 50px;
          // padding: 55px 120px 49px 46px;
          z-index: 2;
          .gif {
            width: 863px;
            height: 427px;
            
  // image-rendering: -webkit-optimize-contrast;
  // image-rendering: optimizeQuality;

          }
          // .design {
          //   position: absolute;
          //   width: 383px;
          //   height: 337px;
          //   left: -200px;
          //   top: 170px;
          // }
          // .bg {
          //   position: absolute;
          //   width: 419px;
          //   height: 499px;
          //   right: 86px;
          //   top: 0;
          //   z-index: -1;
          // }
          // .daoru {
          //   position: absolute;
          //   width: 89px;
          //   height: 37px;
          //   left: -28px;
          //   top: 310px;
          // }
          // .fabu {
          //   position: absolute;
          //   width: 232px;
          //   height: 181px;
          //   right: 68px;
          //   top: 176px;
          // }
          // .quality {
          //   position: absolute;
          //   width: 115px;
          //   height: 136px;
          //   right: 122px;
          //   top: 0px;
          // }
        }
      }
    }
    // .green-plan {
    //   margin-top: 80px;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    //   position: relative;
    //   z-index: 2;
    //   &::after {
    //     content: "";
    //     position: absolute;
    //     width: 282px;
    //     height: 223px;
    //     right: -60px;
    //     top: 0;
    //     background: url(../../assets/images/func-bottom.png) center/cover;
    //     z-index: -1;
    //   }
    //   .left {
    //     flex: 0 0 544px;
    //     width: 544px;
    //     height: 352px;
    //     position: relative;
    //     .cloud-one {
    //       position: absolute;
    //       width: 119px;
    //       height: 36px;
    //       top: 15px;
    //       left: 200px;
    //       animation: moveleft 3s infinite linear;
    //     }
    //     .cloud-two {
    //       position: absolute;
    //       width: 80px;
    //       height: 21px;
    //       top: 15px;
    //       left: 350px;
    //       animation: moveleft 3s infinite linear;
    //     }
    //     .light {
    //       position: absolute;
    //       width: 66px;
    //       height: 69px;
    //       top: 93px;
    //       left: 250px;
    //       .light-y {
    //         position: absolute;
    //         top: 0;
    //         left: 0;
    //         width: 100%;
    //         height: 100%;
    //         opacity: 0;
    //         animation: light 4s infinite linear;
    //       }
    //     }
    //     .light-two {
    //       position: absolute;
    //       width: 114px;
    //       height: 43px;
    //       top: 60px;
    //       left: 225px;
    //       animation: light-two 4s infinite linear;
    //     }
    //     .text-one {
    //       position: absolute;
    //       width: 93px;
    //       height: 28px;
    //       top: 110px;
    //       left: 425px;
    //       animation: text 4s infinite linear;
    //     }
    //     .text-two {
    //       position: absolute;
    //       width: 93px;
    //       height: 28px;
    //       top: 60px;
    //       left: 400px;
    //       animation: text 4s infinite linear;
    //     }
    //     .water {
    //       position: absolute;
    //       width: 50px;
    //       height: 50px;
    //       left: 232px;
    //       top: 220px;
    //       .water-one {
    //         position: absolute;
    //         width: 17px;
    //         height: 14px;
    //         top: 0;
    //         left: 0;
    //         animation: water-one 4s infinite linear;
    //       }
    //       .water-two {
    //         position: absolute;
    //         width: 19px;
    //         height: 15px;
    //         top: 10px;
    //         left: 7px;
    //         animation: water-two 4s infinite linear;
    //       }
    //       .water-three {
    //         position: absolute;
    //         width: 26px;
    //         height: 15px;
    //         top: 26px;
    //         left: 7px;
    //         animation: water-three 4s infinite linear;
    //       }
    //     }
    //     .yezi-one {
    //       position: absolute;
    //       width: 22px;
    //       height: 37px;
    //       top: 241px;
    //       left: 223px;
    //       transform-origin: bottom;
    //       animation: swing 3s infinite linear;
    //     }
    //     .yezi-two {
    //       position: absolute;
    //       width: 44px;
    //       height: 30px;
    //       top: 252px;
    //       left: 240px;
    //       transform-origin: bottom;
    //       animation: swing 3s infinite linear;
    //     }
    //   }
    //   .right {
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: center;
    //     width: 420px;
    //     .min-title {
    //       font-size: 26px;
    //       color: #444;
    //       line-height: 30px;
    //       span {
    //         font-size: 30px;
    //         font-family: "PingFangSC-Medium", sans-serif;
    //       }
    //     }
    //     p {
    //       margin-top: 28px;
    //       color: #444;
    //       font-size: 16px;
    //       span {
    //         font-family: PingFang Bold;
    //       }
    //     }
    //   }
    // }
  }
  .Personal-customization {
    position: relative;
    height: 605px;
      background: url(../../assets/images/个性化定制背景.png) center/cover;
      .left-box {
        display: flex;
        align-items: center;
        height: 605px;
      .left {
        position: relative;
        // transform: translateY(-50%);
        flex: 0 0 60%;
        h2 {
            font-size: 26px;
            font-family: 'PingFang SC';
            font-weight: 400;
            color: #191919;
            line-height: 30px;
            opacity: 0.9;
        }
        p {
          &:nth-of-type(1){
            margin: 33px 0;
            font-size: 28px;
            font-family: 'PingFang SC';
            font-weight: 400;
            color: #191919;
            line-height: 30px;
        }
        &:nth-of-type(2){
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #444444;
          line-height: 30px;
        }
        }
        .btn {
          margin-top: 44px;
          width: 120px;
            height: 46px;
            background: #1989FF;
            border-radius: 4px;
            font-size: 16px;
            font-family: 'PingFang SC';
            font-weight: 400;
            color: #FFFFFF;
        }
      }
      }

  }
  .data-safety {
    margin-top: 80px;
    .title {
      color: #191919;
      font-size: 30px;
      text-align: center;
      line-height: 30px;
      margin-bottom: 60px;
      p {
        color: #8a94a9;
        font-size: 16px;
        margin-top: 20px;
      }
    }
    .certificate {
      display: flex;
      margin-bottom: 50px;
      .left {
        color: #444;
        font-size: 26px;
        width: 230px;
        align-self: center;
      }
      .right {
        display: flex;
        justify-content: space-between;
        flex: 0 0 calc(100% - 230px);
        .single-ce {
          flex: 0 0 228px;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background: #fff;
          border-radius: 12px;
          transition: all 0.3s;
          border: 1px solid #fff;
          box-shadow: 0 0 16px rgb(6 27 39 / 14%);
          height: 132px;
          .icon {
            height: 40px;
            line-height: 40px;
            margin-bottom: 10px;
          }
          .text {
            font-size: 12px;
          }
          &:hover {
            border: 1px solid #1989ff;
            transform: translateY(-2px);
          }
        }
      }
    }
    .safety-func {
      display: flex;
      .single-func {
        flex: 0 0 25%;
        text-align: center;
        .icon {
          width: 50px;
          height: 50px;
          position: relative;
          margin: 0 auto 30px;
          img:first-child {
            position: absolute;
            z-index: 1;
            width: 48px;
            height: 48px;
            left: 0;
            top: 0;
            transition: all 0.3s;
          }
          img:last-child {
            position: absolute;
            z-index: 2;
            width: 38px;
            height: 41px;
            bottom: -5px;
            right: -8px;
            transition: all 0.3s;
          }
        }
        &:hover {
          span {
            color: #1989ff;
          }
          p {
            color: #5b6a8a;
          }
          .icon {
            img:first-child {
              top: -5px;
              left: -5px;
            }
            img:last-child {
              bottom: -10px;
              right: -13px;
            }
          }
        }
        span {
          color: #444444;
          font-size: 16px;
          transition: all 0.3s;
        }
        p {
          margin-top: 15px;
          font-size: 14px;
          color: #8a94a9;
        }
      }
      .qz {
        .icon {
          img:first-child {
            width: 48px;
            height: 47px;
          }
          img:last-child {
            width: 30px;
            height: 31px;
          }
        }
      }
      .rz {
        .icon {
          img:first-child {
            width: 52px;
            height: 36px;
          }
          img:last-child {
            width: 44px;
            height: 41px;
          }
        }
      }
      .sc {
        .icon {
          img:first-child {
            width: 51px;
            height: 45px;
          }
          img:last-child {
            width: 35px;
            height: 37px;
          }
        }
      }
    }
  }
  .application {
    margin-top: 100px;
    .title {
      color: #191919;
      font-size: 30px;
      text-align: center;
      line-height: 30px;
      margin-bottom: 60px;
      p {
        color: #8a94a9;
        font-size: 16px;
        margin-top: 20px;
      }
    }

  }
  .partner {
    margin-top: 80px;
    .title {
      color: #191919;
      font-size: 30px;
      text-align: center;
      line-height: 30px;
      margin-bottom: 60px;
    }
    .partner-group {
      overflow: hidden;
      position: relative;
      .leftw {
        position: absolute;
        top: 0;
        left: 0;
        width: 80px;
        height: 100%;
        background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
        z-index: 2;
      }
      .rightw {
        position: absolute;
        top: 0;
        right: 0;
        width: 80px;
        height: 100%;
        background: linear-gradient(to left, #fff, rgba(255, 255, 255, 0));
        z-index: 2;
      }
      .parner-bg {
        background: url(../../assets/images/partner.png) 50% / contain repeat-x;
        width: 660vw;
        height: 320px;
        animation: Index-module_scrollToRight_HaAA0 60s infinite linear;
      }
    }
  }
  .contact {
    margin-top: 80px;
    background: url(../../assets/images/bg-contact.png) center/cover;
    .contact-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 13px 0 14px;
      .left {
        h3 {
          color: #444;
          font-size: 26px;
          margin-bottom: 60px;
          font-family: "PingFangSC-Semibold", sans-serif;
        }
        .btn {
          a {
            display: inline-block;
            width: 120px;
            height: 46px;
            line-height: 46px;
            border: 1px solid #1989ff;
            border-radius: 4px;
            color: #1989ff;
            font-size: 16px;
            text-align: center;
            text-decoration: none;
            &:hover {
              background: #e6f2ff;
            }
          }
          .bg {
            margin-left: 50px;
            background: #1989ff;
            color: #fff;
            &:hover {
              background: #0b72df;
            }
          }
        }
      }
      .right {
        width: 468px;
        height: 329px;
        .contact-img {
          position: relative;
          .poab {
            position: absolute;
            width: 52px;
            height: 60px;
            left: 76%;
            top: 40%;
            animation: top-bottom 3s infinite linear;
          }
          .yan {
            position: absolute;
            width: 24px;
            height: 63px;
            left: 91%;
            top: 40%;
            animation: yan 2s infinite linear;
          }
          .contact-light {
            position: absolute;
            width: 57px;
            height: 25px;
            left: 10%;
            top: 27%;
            animation: opacity 2s infinite linear;
          }
        }
      }
    }
  }
}

@-webkit-keyframes Index-module_scrollToRight_HaAA0 {
  0% {
    -webkit-transform: translate3d(-50%, 0, 0);
  }
  to {
    -webkit-transform: translateZ(0);
  }
}
@keyframes Index-module_scrollToRight_HaAA0 {
  0% {
    -webkit-transform: translate3d(-50%, 0, 0);
  }
  to {
    -webkit-transform: translateZ(0);
  }
}

@keyframes top-bottom {
  0% {
    top: 40%;
  }
  25% {
    top: 45%;
  }
  50% {
    top: 50%;
  }
  75% {
    top: 45%;
  }
  100% {
    top: 40%;
  }
}
@keyframes yan {
  0% {
    opacity: 1;
  }
  50% {
    transform: translateY(-10px);
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}

@keyframes opacity {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 0;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

@keyframes light {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes light-two {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes text {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(50px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes water-one {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes water-two {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes water-three {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes certificate-one {
  0% {
    transform: translateY(0px);
  }
  16% {
    transform: translateY(-10px);
  }
  32% {
    transform: translateY(0px);
  }
  48% {
    transform: translateY(0px);
  }
  64% {
    transform: translateY(0px);
  }
  80% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes certificate-two {
  0% {
    transform: translateY(0px);
  }
  16% {
    transform: translateY(0px);
  }
  32% {
    transform: translateY(-10px);
  }
  48% {
    transform: translateY(0px);
  }
  64% {
    transform: translateY(0px);
  }
  80% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes certificate-three {
  0% {
    transform: translateY(0px);
  }
  16% {
    transform: translateY(0px);
  }
  32% {
    transform: translateY(0px);
  }
  48% {
    transform: translateY(-10px);
  }
  64% {
    transform: translateY(0px);
  }
  80% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes certificate-four {
  0% {
    transform: translateY(0px);
  }
  16% {
    transform: translateY(0px);
  }
  32% {
    transform: translateY(0px);
  }
  48% {
    transform: translateY(0px);
  }
  64% {
    transform: translateY(-10px);
  }
  80% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes certificate-five {
  0% {
    transform: translateY(0px);
  }
  16% {
    transform: translateY(0px);
  }
  32% {
    transform: translateY(0px);
  }
  48% {
    transform: translateY(0px);
  }
  64% {
    transform: translateY(0px);
  }
  80% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes flow-one {
  0% {
    transform: rotate(-27deg) scaleX(0);
  }
  15% {
    transform: rotate(-27deg) scaleX(1);
  }
  20% {
    transform: rotate(-27deg) scaleX(1);
  }
  40% {
    transform: rotate(-27deg) scaleX(1);
  }
  60% {
    transform: rotate(-27deg) scaleX(1);
  }
  80% {
    transform: rotate(-27deg) scaleX(1);
  }
  100% {
    transform: rotate(-27deg) scaleX(1);
  }
}
@keyframes flow-five {
  0% {
    transform: rotate(7deg) scaleX(0);
  }
  15% {
    transform: rotate(7deg) scaleX(0);
  }
  20% {
    transform: rotate(7deg) scaleX(1);
  }
  40% {
    transform: rotate(7deg) scaleX(1);
  }
  60% {
    transform: rotate(7deg) scaleX(1);
  }
  80% {
    transform: rotate(7deg) scaleX(1);
  }
  100% {
    transform: rotate(7deg) scaleX(1);
  }
}
@keyframes flow-two {
  0% {
    transform: rotate(-59deg) scaleY(0);
  }
  20% {
    transform: rotate(-59deg) scaleY(0);
  }
  40% {
    transform: rotate(-59deg) scaleY(1);
  }
  60% {
    transform: rotate(-59deg) scaleY(1);
  }
  80% {
    transform: rotate(-59deg) scaleY(1);
  }
  100% {
    transform: rotate(-59deg) scaleY(1);
  }
}
@keyframes flow-three {
  0% {
    transform: rotate(-30deg) scaleX(0);
  }
  20% {
    transform: rotate(-30deg) scaleX(0);
  }
  40% {
    transform: rotate(-30deg) scaleX(0);
  }
  60% {
    transform: rotate(-30deg) scaleX(1);
  }
  80% {
    transform: rotate(-30deg) scaleX(1);
  }
  100% {
    transform: rotate(-30deg) scaleX(1);
  }
}
@keyframes flow-four {
  0% {
    transform: rotate(-53deg) scaleY(0);
  }
  20% {
    transform: rotate(-53deg) scaleY(0);
  }
  40% {
    transform: rotate(-53deg) scaleY(0);
  }
  60% {
    transform: rotate(-53deg) scaleY(0);
  }
  80% {
    transform: rotate(-53deg) scaleY(1);
  }
  100% {
    transform: rotate(-53deg) scaleY(1);
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@keyframes moveleft {
  0% {
    opacity: 1;
  }
  25% {
    transform: translateX(-25px);
    opacity: 0.75;
  }
  50% {
    transform: translateX(-50px);
    opacity: 0.5;
  }
  75% {
    transform: translateX(-75px);
    opacity: 0.25;
  }
  100% {
    transform: translateX(-100px);
    opacity: 0;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
